import { supabase } from '@/lib/supabase';
import { track, EVENTOS } from '@/lib/analytics';

// Regista o que os visitantes pesquisam (tabela pesquisas_log, escrita só via
// RPC log_pesquisa). Nunca pode partir a pesquisa: qualquer erro é ignorado.

const SESSION_KEY = 'tamoaki_search_session';

function getSessionId(): string | null {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

export type SearchClickType = 'categoria' | 'subcategoria' | 'servico' | 'prestador';

// De onde veio a pesquisa — separa no relatório do admin a barra principal,
// o diretório (/prestadores) e "Na sua zona" (/nearby-search).
export type SearchOrigem = 'barra_unificada' | 'diretorio' | 'na_zona';

export function logSearch(term: string, resultCount: number, clickedType?: SearchClickType, origem: SearchOrigem = 'barra_unificada'): void {
  const clean = term.trim();
  if (clean.length < 2) return;
  // PostHog: uma pesquisa conta uma vez (o clique num resultado chama logSearch
  // outra vez, com clickedType). Não enviamos o texto pesquisado, só o tamanho.
  if (!clickedType) {
    track(EVENTOS.searchStarted, { origem, n_resultados: resultCount, sem_resultados: resultCount === 0, tamanho_termo: clean.length });
  }
  try {
    void supabase
      .rpc('log_pesquisa', {
        p_termo: clean,
        p_n_resultados: resultCount,
        p_clicou_tipo: clickedType ?? null,
        p_sessao: getSessionId(),
        p_origem: origem,
      })
      .then(() => undefined, () => undefined);
  } catch {
    // ignorado de propósito
  }
}
